import { h } from 'preact';
import * as is from 'utilities/is';
import { alphabeticOrdinal } from 'utilities/list';

export const QuizProgress = ({
    segments = 1,
    progress = 0,
    describeProgress = true,
    currentAnswer
}) => {
    
    const accessibility = {
        role: 'progressbar',
        ['aria-valuenow']: progress,
        ['aria-valuemin']: 0,
        ['aria-valuemax']: segments,
        ['aria-valuetext']: `Question ${progress} of ${segments}`
    }

    return (
        <div className="quiz-progress">
            <div className="progress" {...accessibility}>
                <div className="segments">
                {
                    Array.from({length: segments})
                        .map((s,i) => {
                                const attrs = {
                                    className: 'progressSegment'
                                };

                                if (i < progress) {
                                    attrs['data-progressed'] = true;
                                }

                                return <div {...attrs} />
                            }
                        )
                }
                </div>
                { 
                    describeProgress &&
                        <div className="label">
                            <div className="currentQuestion">
                                <div>Question</div>
                                <div>{progress} of {segments}</div>
                            </div>
                            <div className="divider"></div>
                            <div className="selectedAnswer">
                                <div>Your Answer</div>
                                <div>{currentAnswer > -1 ? alphabeticOrdinal(currentAnswer) : null}</div>
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}